/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  LinkAction,
  LinkAction$inboundSchema,
  LinkAction$Outbound,
  LinkAction$outboundSchema,
} from "./linkaction.js";
import {
  SettingAction,
  SettingAction$inboundSchema,
  SettingAction$Outbound,
  SettingAction$outboundSchema,
} from "./settingaction.js";

/**
 * Actions to take
 */
export type Actions = {
  /**
   * A link action.
   */
  linkAction?: LinkAction | undefined;
  /**
   * The actions that are executed when the option is selected.
   */
  settingActions?: Array<SettingAction> | undefined;
};

/** @internal */
export const Actions$inboundSchema: z.ZodType<Actions, z.ZodTypeDef, unknown> =
  z.object({
    link_action: types.optional(LinkAction$inboundSchema),
    setting_actions: types.optional(z.array(SettingAction$inboundSchema)),
  }).transform((v) => {
    return remap$(v, {
      "link_action": "linkAction",
      "setting_actions": "settingActions",
    });
  });
/** @internal */
export type Actions$Outbound = {
  link_action?: LinkAction$Outbound | undefined;
  setting_actions?: Array<SettingAction$Outbound> | undefined;
};

/** @internal */
export const Actions$outboundSchema: z.ZodType<
  Actions$Outbound,
  z.ZodTypeDef,
  Actions
> = z.object({
  linkAction: LinkAction$outboundSchema.optional(),
  settingActions: z.array(SettingAction$outboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    linkAction: "link_action",
    settingActions: "setting_actions",
  });
});

export function actionsToJSON(actions: Actions): string {
  return JSON.stringify(Actions$outboundSchema.parse(actions));
}
export function actionsFromJSON(
  jsonString: string,
): SafeParseResult<Actions, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Actions$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Actions' from JSON`,
  );
}
